import Vue from 'vue'
import Vuex from 'vuex'

import app from './app'
import search from './search'
import onetrust from './onetrust/onetrust-store'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    search,
    onetrust,
  }
})
